import React, { useEffect, useRef } from 'react';
import { Container } from 'react-bootstrap';
import { useSelector } from "react-redux";
import AddIngredients from '../../../components/OrderAnItem/ItemCustomization/AddIngredients';
import { SINGLE_ITEM_SELECTED_SECTION } from '../../../constants';
import { verifyStatus } from '../../../helpers/customizedItem/customizedItem.helper';
import useCheckMobileScreen from '../../../hooks/useCheckMobileScreen';
import { IItemCustomization } from '../../../models/item.model';
import { IModifiersObjects } from '../../../models/try2Combo';
import { itemBuckets } from '../../../priceCalculation/buckets';
import { removeTemporarilyAddedPriceForItem, resetModifiers } from '../../../redux/slices/itemCustomizationSlice';
import { useAppDispatch } from '../../../redux/store/store';
import styleClasses from '../order.module.scss';
import CustomizationModal from './CustomizationModal';

const Customization: React.FC<IItemCustomization> = (props) => {
  const {
    item,
    showCustomization,
    showCustomizedOptions,
    handleIngredientSelection,
    modalShow,
    handleSyncIngredients,
    hideModifierModal,
    unrepeatedIngredients,
    autoScrollDivRef,
    firstTimeModal,
    CYOIScrollToMissingRequiredArea,
    itemAsModifierState,
    openItemInfoModal,
  } = props;

  const order = useSelector((state: any) => state.itemCustomization);
  const modifiers = useRef([]);
  useEffect(()=>{
    if(modalShow){
      modifiers.current = [...order?.modifiers]
    }
  },[modalShow])

  const dispatch = useAppDispatch();
  const isItMobile = useCheckMobileScreen()

  const applyClickHandler = () => {
    itemBuckets.resetCopyComboBucket();
    hideModifierModal()
  }

  const onModalCancel = () => {
    dispatch(resetModifiers({modifiers:modifiers.current}))
    dispatch(removeTemporarilyAddedPriceForItem({
      price: itemBuckets.discardBucketChanges("1"),
      item: "1",
    }))
    hideModifierModal()
  }

  return (
    <div>
      {item.is_active &&
        verifyStatus(item, 'item_location') &&
        (showCustomizedOptions || showCustomization ) && (
          <div ref={autoScrollDivRef}
            className={`${styleClasses.customize_content_wrapper} d-none d-md-block`}
          >
            { !firstTimeModal && 
            <div
              className={`${styleClasses.customize_card_header} d-flex align-items-center card_title_wrap mb-4`}
            >
              <h2 className="clr-dark-red text-start text-uppercase f-s22 f-sm-s20 text-style-none mb-0" data-testid="customizeDiv" >
                Customize
              </h2>
            </div>
          }
            <Container fluid className="px-0" data-testid="customizeMenu">
                <>
                  {(!isItMobile && !firstTimeModal) ? (
                    <AddIngredients
                      modifierGroups={item?.items_modifier_groups}
                      order={order}
                      coreModifiers={item?.core_modifiers}
                      requiredModifiers={item?.items_required_modifier_groups}
                      itemsAsModifiers={item?.sub_items_required_modifier_groups}
                      itemAsModifierState={itemAsModifierState}
                      parentTrayItem={item}
                      openItemInfoModal={openItemInfoModal}
                      handleIngredientSelection={(data: IModifiersObjects) =>
                        handleIngredientSelection(data, SINGLE_ITEM_SELECTED_SECTION)
                      }
                      selectedItem={'1'}
                      handleSyncIngredients={handleSyncIngredients}
                      sectionSelected={'1'}
                      itemName={item?.name}
                      is_create_your_own={item?.is_create_your_own}
                      showCustomization={showCustomization}
                      CYOIScrollToMissingRequiredArea={CYOIScrollToMissingRequiredArea}
                    />
                  ) : (
                    <CustomizationModal
                      modalShow={modalShow}
                      onModalCancel={onModalCancel}
                      item={item}
                      handleIngredientSelection={handleIngredientSelection}
                      handleSyncIngredients={handleSyncIngredients}
                      styleClasses={styleClasses}
                      applyClickHandler={applyClickHandler}
                      showCustomization={showCustomization}
                      CYOIScrollToMissingRequiredArea={CYOIScrollToMissingRequiredArea}
                      order={order}
                      itemAsModifierState={itemAsModifierState}
                      openItemInfoModal={openItemInfoModal}
                    />
                  )}
                </>
              {/* )} */}
            </Container>
          </div>
        )}
    </div>
  );
};

export default Customization;